import {OfferDurationTranslation} from '@core/shared/models/offer/offer-duration-translation';

export type OfferDurationType = 'day' | 'stay';

export const OFFER_DURATION_TYPES: OfferDurationType[] = ['day', 'stay'];

export interface OfferDuration {

    id: number;

    createdAt?: string;

    updatedAt?: string;

    limitLocation: number;

    limitProgram: number;

    value: number;

    type: OfferDurationType | null;

    translations: OfferDurationTranslation[];
}

export interface OfferDurationFilterOption {

    identifier: string;

    label: string;

    id: number;

    parentIdentifier?: string;

    children?: OfferDurationFilterOption[];
}
